// extracted by mini-css-extract-plugin
export default {"title":"Code_title__EJ7b6","info":"Code_info__IDV-B","code":"Code_code__CshBX","number":"Code_number__-PhJs"};